import Loadable from 'react-loadable';
import Loading from './Loading';

export default Loadable({
  loader: () => import(/* webpackChunkName: "design-system-footer-user-settings" */ './UserSettings'),
  loading: Loading,
});
